import React from 'react';
import { AllTicketsRow } from '../callCenterAllTicketsTypes';
import { PriorityBadge, StatusBadge, ViewButton } from '../../shared';
import styles from './TicketsTable.module.css';

interface TicketsTableProps {
  rows: AllTicketsRow[];
  onView?: (id: string) => void;
}

export const TicketsTable: React.FC<TicketsTableProps> = ({ rows, onView }) => {
  return (
    <div className={styles.card}>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>CREATED BY</th>
              <th>MODULE</th>
              <th>CUSTOMER</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ASSIGNED TO</th>
              <th>LAST UPDATED</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={styles.ticketId}>{row.ticketId}</td>
                <td>{row.createdBy}</td>
                <td className={`${styles.module} ${styles[`module_${row.module.toLowerCase()}`]}`}>
                  {row.module}
                </td>
                <td className={styles.bold}>{row.customer}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>{row.assignedTo}</td>
                <td className={styles.muted}>{row.lastUpdated}</td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
